'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z' });

var DesktopMac = function DesktopMac(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

DesktopMac = (0, _pure2.default)(DesktopMac);
DesktopMac.muiName = 'SvgIcon';

exports.default = DesktopMac;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/DesktopMac.js
// module id = 2306
// module chunks = 0